import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { CheckCircleIcon } from '@heroicons/react/24/outline';

const RedirectingOKPage: React.FunctionComponent<{webhotelierId?: string}> = ({webhotelierId = ''}) => {

	const navigate = useNavigate();

	useEffect(() => {
		const timer = setTimeout(() => navigate('/oauth2/redirect?webhotelierId='+ webhotelierId), 2000);
		return () => {
			if (!!timer) clearTimeout(timer);
		};
	}, []);

	return <div className="min-h-full bg-white">
		<div className="flex min-h-full h-dvh flex-1 items-center px-8">
			<div className="mx-auto">
				<div className="flex flex-col items-center justify-center">
					<div>
						<CheckCircleIcon className="h-20 w-20 text-green-400" />
					</div>
					<div className="mt-6">
						<img
							className="h-6 w-auto"
							src="/assets/img/brand/rp-logo.svg"
							alt="RoomPulse"
						/>
					</div>
				</div>

			</div>
		</div>
	</div>;
};

export default RedirectingOKPage;